module.exports = __webpack_public_path__ + "Flama-Extrabold.woff?af5fa357ebc2eb1387c42adecdec4471";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Extrabold.woff
// module id = 918
// module chunks = 0